import { ServiceTypeSortOption } from '@rematter/frontend-lib-api-client';

import { ServiceTypeRecord } from '~/modules/transportation/types';
import { createQueryHook } from '~/shared/providers/api';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export interface ServiceTypesFilter {
  ids?: string[];
  name?: string;
  isActive?: boolean;
  isSystemDefault?: boolean;
  searchTerm?: string;
}

interface GetServiceTypesVariables {
  filter?: ServiceTypesFilter;
  sorting?: ServiceTypeSortOption[];
  pagination?: {
    offset: number;
    limit: number;
  };
}

export const useServiceTypesListQuery = createQueryHook(
  'transportation.serviceTypesList',
  (variables: GetServiceTypesVariables) => ({
    serviceTypes: {
      __args: {
        filter: variables.filter,
        pagination: variables.pagination,
        sorting: variables.sorting ?? ['NameAsc'],
      },
      page: {
        total: true,
      },
      entries: {
        id: true,
        name: true,
        description: true,
        isActive: true,
        isSystemDefault: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data): { serviceTypes: ServiceTypeRecord[]; total: number } => ({
      serviceTypes: (data?.serviceTypes?.entries ?? []).map((serviceType) => ({
        id: serviceType.id,
        name: serviceType.name,
        description: serviceType.description ?? undefined,
        isActive: serviceType.isActive,
        isSystemDefault: serviceType.isSystemDefault,
        timestamps: {
          createdAt: parseZonedDateTime(serviceType.timestamps.createdAt),
          updatedAt: parseZonedDateTime(serviceType.timestamps.updatedAt),
        },
      })),
      total: data?.serviceTypes?.page?.total ?? 0,
    }),
  },
);
